import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getMaterialInfo(params) {
  return request({
    url: `${v2Host}/res_store/info`,
    method: 'get',
    params: params
  })
}
